<!-- <h3 mat-dialog-title></h3> -->
<button data-test-id="message-model.close-button" class="btn-close" (click)="closeAlert()" *ngIf="showCloseButton"><sm-icon name="close"></sm-icon></button>
<mat-dialog-content>
  <div *ngIf="!isLoading; else loadingTemplate">
    <mat-icon class="dialog-icon" [color]="type">warning</mat-icon>
    <div class="text-headline-3" [innerHTML]="message" data-test-id="message-model.message-value"></div>
  </div>
  <ng-template #loadingTemplate>
    <div class="dialog-processing-header">
      <mat-spinner [diameter]="spinnerSize"></mat-spinner>
      <div class="text-headline-3" [innerHTML]="message" data-test-id="message-model.loading-message-value"></div>
    </div>
  </ng-template>
</mat-dialog-content>
